import { useMemo } from 'react'
import { calcWolf } from './ggWolf.js'
import { samplePlayers } from './ggSamplePlayers.js'

// G-Wolf — isolated sandbox. Wolf rotates each hole, partnering up or going Lone
// Wolf. calcWolf ported verbatim from GolfGamesScorecard. Uses the first four
// sample players with a deterministic wolf/partner/lone schedule.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }

export default function GWolf() {
  const players = useMemo(() => samplePlayers().slice(0, 4), [])
  const wolfData = useMemo(() => {
    const ids = players.map((p) => p.id)
    return Array.from({ length: 18 }, (_, h) => {
      const wolfId = ids[h % 4]
      const loneWolf = h % 5 === 4
      const partnerId = loneWolf ? null : ids[(h + 1) % 4]
      return { hole: h, wolfId, partnerId, loneWolf }
    })
  }, [players])
  const rows = useMemo(() => calcWolf(players, wolfData), [players, wolfData])

  return (
    <div className="card">
      <p className="text-sm text-gray-500 mb-3">Lone Wolf win 3 (loss: 2 to each opponent). Partnered win 1 each (loss: 2 to the others). Wolf rotates each hole.</p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Pos', 'Player', 'Points'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>{rows.map((p, i) => (
          <tr key={p.id}><td style={cell}>{i + 1}</td><td style={cell}>{p.name}</td><td style={cell}><b>{p.points}</b></td></tr>
        ))}</tbody>
      </table>
    </div>
  )
}
